import { useSelector } from 'react-redux'
import { addToCart } from 'actions/orders.action'
import { useAppDispatch } from 'hooks/useAppDispatch'
import { RootState } from 'reducers/rootReducer'
import { CartItem } from 'models/IDeliveryOrder'

export const useAddToCart = (props: { productId: number }) => {
  const { productId } = props
  const dispatch = useAppDispatch()

  const products = useSelector((state: RootState) => state.products.products)
  const cart = useSelector((state: RootState) => state.orders.cart) || []
  const isAddingToCart = useSelector(
    (state: RootState) => state.orders.isAddingToCart
  )

  const product = products?.find((p) => p.id === productId)
  const hasVariants = !!(product?.priceList && product.priceList.length > 0)
  const priceList = product?.priceList || []
  const hasLongNames = priceList.some((v) => v.name.length > 3)

  const handleToggle = (variantName: string | null = null) => {
    const cartItem: CartItem = {
      productId,
      quantity: 1,
      variantName: variantName,
    }
    dispatch(addToCart(cartItem))
  }

  const isVariantAdded = (variantName: string | null = null) => {
    return cart.some(
      (item) => item.productId === productId && item.variantName === variantName
    )
  }

  return {
    isAddingToCart,
    hasVariants,
    hasLongNames,
    priceList,
    handleToggle,
    isVariantAdded,
  }
}
